import { find } from "lodash";
import { CategoryField, CategoryObject } from "../../typings/categories";
import { FIELDS, PREMIUM_DESCRIPTION_MIN_LENGTH } from "../../thor.const";
import categories from "../../../assets/json/categories.json";
import { thor } from "../../typings/thor";

enum CategoryNotDeliverable {
    SportClassicCars = 265,
    HorseDrawnCarriages = 266,
    NFT = 267
}

class CategoryService {
    public static $inject: string[] = ["$log", "$translate", "utilsService"];

    private fields: any = FIELDS;
    private categories: any = categories;

    private $t;

    constructor(private $log: ng.ILogService, $translate: ng.translate.ITranslateService, private utilsService) {
        this.$t = $translate.instant;
        this.translate();
    }

    public checkPremiumCriteria({ category, description, media_count }: thor.ItemGet): boolean {
        return Boolean(
            categories.find(c => c.id === category?.id)?.premium &&
            description?.length >= PREMIUM_DESCRIPTION_MIN_LENGTH &&
            media_count > 0
        );
    }

    public isCategoryPremium({ category }: thor.ItemGet): boolean {
        return categories.find(c => c.id === category?.id)?.premium;
    }

    public isCategoryDeliverable({ category }: thor.ItemGet): boolean {
        return !Object.values(CategoryNotDeliverable).includes(category?.id);
    }

    public getFields() {
        return this.fields;
    }

    public getCategories() {
        return this.categories;
    }

    public getCategoryField(categoryId) {
        if (!this.categories) {
            this.$log.error("categories list is not filled");
            return null;
        }
        const category = find(this.categories, { id: categoryId });

        if (!category) {
            this.$log.error(`category ${categoryId} not found in list`);
            return null;
        }

        return category.field;
    }

    public getFieldLabel(fieldKey: CategoryField): string {
        const matchedField = this.fields.find(field => field.key === fieldKey);

        return matchedField && matchedField.label ? matchedField.label : "";
    }

    public getCategoryName(id: number): string {
        const category = this.categories.find((cat: CategoryObject) => cat.id === id);
        return (category && category.name) || undefined;
    }

    public translate() {
        this.fields.forEach(field => (field.label = this.$t(field.i18n)));
        this.categories.forEach((category: CategoryObject) => (category.name = this.$t(category.i18n)));

        this.categories.sort((a, b) => this.utilsService.stringSort(a, b, "name"));
    }
}

angular.module("thor.core.category.service", []).service("categoryService", CategoryService);
